import { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { http } from "@/lib/api";

/** Defaults shown when admin hasn't customised the FAQs yet. */
export const FAQ_DEFAULTS = [
  { q: "How long does shipping take?", a: "Most orders ship within 3-5 business days. Domestic delivery typically arrives 5-10 days after shipping. Tracking is emailed when your package leaves the studio." },
  { q: "How do digital downloads work?", a: "After your payment is confirmed, your digital files are available from your account under Downloads. You'll also receive a download link via email." },
  { q: "What print sizes do you offer?", a: "Every piece is available as a 4x6 print, 11x14, 16x20, and a 16x20 canvas. Some pieces also offer a personal-note upgrade hand-written by Mickey." },
  { q: "How does the weekly subscription work?", a: "Subscribers receive a new piece from the Collection each week — digital, print, or premium — with the story behind it and a quiet reminder to live with intention." },
  { q: "How do I pay with Cash App or Venmo?", a: "Choose Cash App or Venmo at checkout. We'll generate an order number and ask you to send payment to $MickeyTrivett (Cash App) or @MickeyTrivett (Venmo). Include the order number in the note. Once verified, your order ships." },
  { q: "Can I get a refund?", a: "Yes — for prints and canvas, within 14 days of delivery if it arrives damaged or you change your mind (unused condition). Digital downloads are non-refundable once accessed." },
  { q: "What is a QR-code purchase?", a: "Some pieces are displayed on real walls around town. Scan the code, read the story, choose a format, and buy it — right from your phone. You'll get a proof-of-purchase page after you complete checkout." },
  { q: "What is a Personal Text Upgrade?", a: "An add-on where Mickey hand-writes a personal note tied to the meaning of your chosen piece. Tucked into your shipment as a quiet reminder." },
];

export default function FAQ() {
  const [faqs, setFaqs] = useState(FAQ_DEFAULTS);
  const [heading, setHeading] = useState({ eyebrow: "Frequently Asked", title: "QUESTIONS." });

  useEffect(() => {
    http.get("/public/content").then(({ data }) => {
      if (Array.isArray(data?.faqs) && data.faqs.length) setFaqs(data.faqs);
      if (data?.faq_heading && typeof data.faq_heading === "object") {
        setHeading({ ...heading, ...data.faq_heading });
      }
    }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Layout>
      <section className="bg-black pt-24 pb-24">
        <div className="max-w-[860px] mx-auto px-6 md:px-12">
          <div className="copper-divider mb-6" data-testid="faq-eyebrow">{heading.eyebrow}</div>
          <h1 className="text-grunge text-5xl text-[#F5F2EB] mb-12" data-testid="faq-title">{heading.title}</h1>

          {faqs.length === 0 ? (
            <p className="font-body italic text-[#8a857d]">FAQs coming soon.</p>
          ) : (
            <Accordion type="single" collapsible className="space-y-3" data-testid="faq-accordion">
              {faqs.map((f, i) => (
                <AccordionItem key={i} value={`f${i}`} className="border border-white/10 px-5">
                  <AccordionTrigger data-testid={`faq-q-${i}`} className="font-ui text-[13px] tracking-[0.16em] uppercase text-[#F5F2EB] hover:no-underline text-left">
                    {f.q || f.question}
                  </AccordionTrigger>
                  <AccordionContent className="font-body text-[#A3A3A3] text-base leading-relaxed pb-5 whitespace-pre-line">
                    {f.a || f.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          )}
        </div>
      </section>
    </Layout>
  );
}
